/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': '選択を解除',
  'paginated-picker.async-select.menu-list.error-message.error-message': 'データを取得できませんでした',
  'paginated-picker.async-select.menu-list.error-message.retry-message': 'クリックして再試行',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': '読み込み中…',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': '表示を増やす',
  'paginated-picker.async-select.pagination-details.of-total-count': '{totalCount} 件中 {itemsCount} 件',
  'paginated-picker.async-select.select.no-options-message.no-options-message': '一致するものが見つかりませんでした',
  'paginated-picker.async-select.select.option.error-message': 'データを取得できませんでした',
  'paginated-picker.async-select.select.option.retry-message': 'クリックして再試行',
  'paginated-picker.async-select.select.search-placeholder': '検索',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'リスト全体を表示'
};